/* OR Powersports - Theme JS */

document.addEventListener('DOMContentLoaded', () => {
  initIntroLoader();
  initHeroSlider();
  initPopup();
  initMobileMenu();
  initHeaderScroll();
  initCategoryGrid();
  initPromoProduct();
  initPersonaliza();
  initProductPage();
  initCartPage();
  initCollectionFilters();
  initBrandsPage();
  initFooterMobileAccordion();
  initProductRelated();
  initCatalogMegaMenu();
  initContactForm();
  initProductPhotoFallback();
});

const OR_PRODUCT_PHOTO_PLACEHOLDER_HTML =
  '<div class="or-product-photo-placeholder" role="img" aria-label="Sin foto del producto">' +
  '<svg class="or-product-photo-placeholder__icon" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
  '<rect x="8" y="14" width="48" height="36" rx="4" stroke="currentColor" stroke-width="2"/>' +
  '<circle cx="22" cy="28" r="5" stroke="currentColor" stroke-width="2"/>' +
  '<path d="M12 42l14-12 10 8 8-6 18 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
  '</svg><span class="or-product-photo-placeholder__label">Sin foto</span></div>';

function createOrProductPhotoPlaceholder(label) {
  const wrap = document.createElement('div');
  wrap.innerHTML = OR_PRODUCT_PHOTO_PLACEHOLDER_HTML.trim();
  const node = wrap.firstElementChild;
  if (node && label) node.setAttribute('aria-label', label);
  return node;
}

function swapProductPhotoToPlaceholder(img) {
  if (!img || img.dataset.orPhotoFallback === 'done') return;
  img.dataset.orPhotoFallback = 'done';
  const node = createOrProductPhotoPlaceholder(`Sin foto: ${img.alt || 'producto'}`);
  if (!node) return;
  img.replaceWith(node);
}

function considerProductPhoto(img) {
  if (!img || img.dataset.orPhotoFallback === 'done') return;
  if (img.complete) {
    if (!img.naturalWidth || !img.naturalHeight || (img.naturalWidth < 20 && img.naturalHeight < 20)) {
      swapProductPhotoToPlaceholder(img);
    }
  }
}

function mountOrProductPhoto(img) {
  if (!img) return;
  img.addEventListener('error', () => swapProductPhotoToPlaceholder(img));
  img.addEventListener('load', () => considerProductPhoto(img));
  considerProductPhoto(img);
}

function fillProductCardImageWrap(imageWrap, { src, title }) {
  if (src) {
    const img = document.createElement('img');
    img.src = src;
    img.alt = title || '';
    img.loading = 'lazy';
    img.width = 600;
    img.height = 600;
    img.dataset.orProductPhoto = '';
    imageWrap.appendChild(img);
    mountOrProductPhoto(img);
  } else {
    const node = createOrProductPhotoPlaceholder(title ? `Sin foto: ${title}` : null);
    if (node) imageWrap.appendChild(node);
  }
}

function initProductPhotoFallback() {
  document.querySelectorAll('[data-or-product-photo]').forEach((img) => mountOrProductPhoto(img));
}

function initPersonaliza() {
  const root = document.querySelector('[data-personaliza]');
  if (!root) return;

  const frame = root.querySelector('.personaliza__frame');
  const slides = root.querySelectorAll('[data-personaliza-slide]');
  if (slides.length < 2) return;

  let current = 0;
  let timer = null;
  let pausedByHover = false;
  const interval = Math.max(
    3000,
    parseInt(root.getAttribute('data-personaliza-autoplay') || '3000', 10) || 3000
  );

  function go(index) {
    current = (index + slides.length) % slides.length;
    slides.forEach((slide, idx) => {
      slide.classList.toggle('is-active', idx === current);
    });
  }

  function startAuto() {
    stopAuto();
    if (pausedByHover || document.hidden) return;
    timer = setInterval(() => go(current + 1), interval);
  }

  function stopAuto() {
    if (timer) clearInterval(timer);
    timer = null;
  }

  go(0);
  startAuto();

  root.querySelectorAll('[data-personaliza-prev]').forEach((btn) => {
    btn.addEventListener('click', () => {
      go(current - 1);
      startAuto();
    });
  });
  root.querySelectorAll('[data-personaliza-next]').forEach((btn) => {
    btn.addEventListener('click', () => {
      go(current + 1);
      startAuto();
    });
  });

  frame?.addEventListener('mouseenter', () => {
    pausedByHover = true;
    stopAuto();
  });
  frame?.addEventListener('mouseleave', () => {
    pausedByHover = false;
    startAuto();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stopAuto();
    else startAuto();
  });

  const galleryItems = root.querySelectorAll('.personaliza__gallery-item');
  const touchGallery = window.matchMedia('(hover: none), (max-width: 768px)').matches;
  if (galleryItems.length && touchGallery) {
    galleryItems.forEach((item) => {
      item.addEventListener('click', (e) => {
        if (e.target.closest('.personaliza__gallery-link')) return;
        galleryItems.forEach((el) => el.classList.remove('is-active'));
        item.classList.add('is-active');
      });
    });
    galleryItems[0]?.classList.add('is-active');
  }
}

function initIntroLoader() {
  const loader = document.getElementById('or-loading');
  if (!loader) return;

  document.body.classList.add('or-loading-active');

  const finish = () => {
    loader.classList.remove('is-running');
    loader.classList.add('is-done');
    document.body.classList.remove('or-loading-active');
    setTimeout(() => loader.remove(), 600);
  };

  if (document.readyState === 'complete') {
    setTimeout(finish, 1200);
  } else {
    window.addEventListener('load', () => setTimeout(finish, 1200));
  }
}

function initHeroSlider() {
  const slider = document.querySelector('.hero-slider');
  if (!slider) return;

  const slides = slider.querySelector('.hero-slider__slides');
  const dots = slider.querySelectorAll('.hero-slider__dot');
  const total = slider.querySelectorAll('.hero-slider__slide').length;
  if (!slides || !total) return;

  let current = 0;
  let timer;

  function goTo(index) {
    current = ((index % total) + total) % total;
    slides.style.transform = `translateX(-${current * 100}%)`;
    dots.forEach((d, i) => {
      d.classList.toggle('is-active', i === current);
      d.setAttribute('aria-selected', String(i === current));
    });
  }

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      clearInterval(timer);
      goTo(i);
      startAuto();
    });
  });

  function startAuto() {
    clearInterval(timer);
    if (total < 2) return;
    timer = setInterval(() => goTo(current + 1), 5500);
  }

  let touchStartX = 0;
  slider.addEventListener(
    'touchstart',
    (e) => {
      touchStartX = e.touches[0].clientX;
    },
    { passive: true }
  );
  slider.addEventListener('touchend', (e) => {
    const diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      clearInterval(timer);
      goTo(current + (diff > 0 ? 1 : -1));
      startAuto();
    }
  });

  goTo(0);
  startAuto();
}

function initPopup() {
  const overlay = document.querySelector('.popup-overlay');
  if (!overlay) return;

  const closeBtn = overlay.querySelector('.popup__close');
  const dismissBtn = overlay.querySelector('[data-popup-dismiss]');
  const delay = parseInt(overlay.dataset.delay || '3000', 10);
  const storageKey = 'or_popup_dismissed';

  if (sessionStorage.getItem(storageKey) || sessionStorage.getItem('or_popup_subscribed')) return;

  if (overlay.querySelector('.popup__success')) {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    sessionStorage.setItem(storageKey, '1');
    return;
  }

  if (overlay.querySelector('.popup__error')) {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
  }

  const openTimer = setTimeout(() => {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
  }, delay);

  function close() {
    clearTimeout(openTimer);
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    sessionStorage.setItem(storageKey, '1');
  }

  closeBtn?.addEventListener('click', close);
  dismissBtn?.addEventListener('click', close);
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) close();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
}

function buildOrWhatsAppUrl(phone, message) {
  const digits = String(phone || '').replace(/\D/g, '');
  if (!digits) return '';
  return `https://api.whatsapp.com/send?phone=${digits}&text=${encodeURIComponent(message || '')}`;
}

function initContactForm() {
  const root = document.querySelector('[data-or-contact-form]');
  if (!root) return;

  const waBtn = root.querySelector('[data-or-contact-wa]');
  if (!waBtn) return;

  const phone = root.getAttribute('data-or-wa-phone') || '';

  waBtn.addEventListener('click', () => {
    const form = root.querySelector('form');
    if (!form) return;

    const name = form.querySelector('[name="contact[name]"]')?.value?.trim() || '';
    const email = form.querySelector('[name="contact[email]"]')?.value?.trim() || '';
    const tel = form.querySelector('[data-or-contact-phone]')?.value?.trim() || '';
    const topic = form.querySelector('[data-or-contact-topic]')?.value?.trim() || 'Consulta';
    const message = form.querySelector('[data-or-contact-message]')?.value?.trim() || '';

    if (!message) {
      form.querySelector('[data-or-contact-message]')?.focus();
      return;
    }

    const lines = [
      `Hola Original Rider, soy ${name || 'un cliente'}.`,
      `Motivo: ${topic}`,
      message,
      email ? `Correo: ${email}` : '',
      tel ? `Tel/WhatsApp: ${tel}` : '',
    ].filter(Boolean);

    const url = buildOrWhatsAppUrl(phone, lines.join('\n'));
    if (url) window.open(url, '_blank', 'noopener,noreferrer');
  });
}

function initHeaderScroll() {
  const els = document.querySelectorAll('.site-header, .announcement-bar');
  if (!els.length) return;
  const onScroll = () => {
    const scrolled = window.scrollY > 40;
    els.forEach((el) => el.classList.toggle('is-scrolled', scrolled));
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
}

function initCategoryGrid() {
  const items = document.querySelectorAll('.category-grid__item');
  if (!items.length) return;

  const touchUi = window.matchMedia('(hover: none), (max-width: 768px)').matches;

  function activate(item) {
    items.forEach((el) => el.classList.remove('is-active'));
    item.classList.add('is-active');
  }

  items.forEach((item) => {
    item.addEventListener('mouseenter', () => {
      if (touchUi) return;
      activate(item);
    });
    if (touchUi) {
      item.addEventListener('click', (e) => {
        if (e.target.closest('.category-grid__wa')) return;
        if (e.target.closest('.category-grid__hit')) return;
        if (item.classList.contains('is-active')) return;
        e.preventDefault();
        activate(item);
      });
    }
  });

  if (touchUi) items[0]?.classList.add('is-active');
}

function initPromoProduct() {
  const root = document.querySelector('.promo-product');
  if (!root) return;

  const track = root.querySelector('.promo-product__track');
  const dotsEl = root.querySelector('.promo-product__dots');
  const pages = track.querySelectorAll('.promo-product__page');
  if (!track || pages.length < 2 || !dotsEl) return;

  const viewport = root.querySelector('.promo-product__viewport');
  let current = 0;
  let timer = null;

  pages.forEach((_, i) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'promo-product__dot' + (i === 0 ? ' is-active' : '');
    btn.addEventListener('click', () => go(i));
    dotsEl.appendChild(btn);
  });

  function go(index) {
    current = (index + pages.length) % pages.length;
    track.style.transform = `translateX(-${current * 100}%)`;
    dotsEl.querySelectorAll('.promo-product__dot').forEach((d, idx) => {
      d.classList.toggle('is-active', idx === current);
    });
  }

  function start() {
    stop();
    timer = setInterval(() => go(current + 1), 5000);
  }

  function stop() {
    if (timer) clearInterval(timer);
    timer = null;
  }

  go(0);
  start();

  const hoverTarget = viewport || root.querySelector('.promo-product__shell') || root;
  hoverTarget.addEventListener('mouseenter', stop);
  hoverTarget.addEventListener('mouseleave', start);
}

function initMobileMenu() {
  const toggle = document.querySelector('.site-header__hamburger');
  const drawer = document.querySelector('.mobile-drawer');
  if (!toggle || !drawer) return;

  const overlay = drawer.querySelector('.mobile-drawer__overlay');
  const closeBtn = drawer.querySelector('.mobile-drawer__close');

  function setOpen(open) {
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    toggle.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
  }

  toggle.addEventListener('click', () => setOpen(!drawer.classList.contains('is-open')));
  closeBtn?.addEventListener('click', () => setOpen(false));
  overlay?.addEventListener('click', () => setOpen(false));

  drawer.querySelectorAll('[data-search-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => setOpen(false));
  });
}

// Search popup
(function () {
  const popup = document.getElementById('search-popup');
  const backdrop = document.querySelector('.search-popup__backdrop');
  if (!popup) return;

  function open() {
    popup.classList.add('is-open');
    backdrop.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    popup.querySelector('.search-popup__input')?.focus();
  }
  function close() {
    popup.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
  }

  document.querySelectorAll('[data-search-toggle]').forEach((btn) => btn.addEventListener('click', open));
  document.querySelectorAll('[data-search-close]').forEach((el) => el.addEventListener('click', close));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
})();

let productGalleryApi = null;

function normalizeProductImageSrc(url) {
  if (!url) return url;
  if (String(url).startsWith('//')) {
    return `${window.location.protocol}${url}`;
  }
  return url;
}

function initProductGallery() {
  const gallery = document.querySelector('[data-product-gallery]');
  if (!gallery) return null;

  const mainImg =
    gallery.querySelector('[data-product-gallery-main]') ||
    gallery.querySelector('#ProductPageImage') ||
    gallery.querySelector('.product-page__product-img');
  const mediaOpen = gallery.querySelector('[data-product-gallery-open]');
  const thumbs = gallery.querySelectorAll('[data-product-thumb]');
  const lightbox = document.getElementById('product-lightbox');
  const lbImg = lightbox?.querySelector('.product-lightbox__img');
  const lbThumbs = lightbox?.querySelectorAll('[data-lightbox-thumb]');

  let items = [];
  try {
    const jsonEl = document.querySelector('[data-product-gallery-json]');
    if (jsonEl) items = JSON.parse(jsonEl.textContent);
  } catch {
    items = [];
  }

  let currentIndex = 0;

  function indexByMediaId(mediaId) {
    if (mediaId == null) return currentIndex;
    const idx = items.findIndex((item) => String(item.id) === String(mediaId));
    return idx >= 0 ? idx : 0;
  }

  function setActiveThumb(mediaId, variantId) {
    const id = mediaId != null ? String(mediaId) : '';
    const variantKey = variantId != null ? String(variantId) : '';
    thumbs.forEach((thumb) => {
      let active = id !== '' && thumb.dataset.mediaId === id;
      if (!active && variantKey) {
        const linked = (thumb.dataset.variantIds || '')
          .split(',')
          .map((v) => v.trim())
          .filter(Boolean);
        active = linked.some((linkedId) => linkedId === variantKey);
      }
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function syncLightboxThumbs() {
    lbThumbs?.forEach((btn) => {
      const active = parseInt(btn.dataset.index, 10) === currentIndex;
      btn.classList.toggle('is-active', active);
    });
  }

  function showImage(src, alt, mediaId, usePreview, variantId) {
    if (!mainImg || !src) return;
    let item = items.find((i) => String(i.id) === String(mediaId));
    if (!item && variantId != null) {
      item = items.find((i) =>
        (i.variant_ids || []).some((vid) => String(vid) === String(variantId))
      );
    }
    const nextSrc = normalizeProductImageSrc(usePreview && item?.preview ? item.preview : src);
    mainImg.removeAttribute('srcset');
    mainImg.removeAttribute('sizes');
    mainImg.src = nextSrc;
    if (alt) mainImg.alt = alt;
    const resolvedId = item?.id ?? mediaId;
    if (resolvedId != null) {
      currentIndex = indexByMediaId(resolvedId);
      setActiveThumb(resolvedId, variantId);
    } else if (variantId != null) {
      setActiveThumb(null, variantId);
    }
    syncLightboxThumbs();
  }

  function renderLightbox() {
    if (!lightbox || !lbImg || !items.length) return;
    const item = items[currentIndex];
    lbImg.src = item.src;
    lbImg.alt = item.alt || '';
    syncLightboxThumbs();
  }

  function openLightbox() {
    if (!lightbox || !items.length) return;
    renderLightbox();
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    lightbox.querySelector('.product-lightbox__close')?.focus();
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function stepLightbox(delta) {
    if (!items.length) return;
    currentIndex = (currentIndex + delta + items.length) % items.length;
    renderLightbox();
    const item = items[currentIndex];
    if (item) showImage(item.src, item.alt, item.id, true);
  }

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', (e) => {
      e.stopPropagation();
      const img = thumb.querySelector('img');
      currentIndex = indexByMediaId(thumb.dataset.mediaId);
      showImage(thumb.dataset.fullSrc, img?.alt || '', thumb.dataset.mediaId, true);
      openLightbox();
    });
  });

  mediaOpen?.addEventListener('click', () => openLightbox());
  mediaOpen?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      openLightbox();
    }
  });

  lightbox?.querySelectorAll('[data-lightbox-close]').forEach((btn) => {
    btn.addEventListener('click', closeLightbox);
  });
  lightbox?.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => stepLightbox(-1));
  lightbox?.querySelector('[data-lightbox-next]')?.addEventListener('click', () => stepLightbox(1));

  lbThumbs?.forEach((btn) => {
    btn.addEventListener('click', () => {
      currentIndex = parseInt(btn.dataset.index, 10) || 0;
      renderLightbox();
      const item = items[currentIndex];
      if (item) showImage(item.src, item.alt, item.id, true);
    });
  });

  document.addEventListener('keydown', (e) => {
    if (!lightbox?.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') stepLightbox(-1);
    if (e.key === 'ArrowRight') stepLightbox(1);
  });

  if (items.length && mainImg) {
    const activeThumb = gallery.querySelector('[data-product-thumb].is-active');
    currentIndex = activeThumb
      ? indexByMediaId(activeThumb.dataset.mediaId)
      : 0;
  }

  return { showImage, setActiveThumb, items };
}

function isPlausibleBrandName(name) {
  const v = String(name || '').trim();
  if (!v || v.length < 2) return false;
  const low = v.toLowerCase();
  if (/^\d/.test(v)) return false;
  if (low.includes('original rider')) return false;
  if (v.includes('/')) {
    const colorish =
      /(azul|blanco|rojo|negro|gris|verde|morado|rosado|amarillo|fluo|letra|naranja|plateado|dorado)/i.test(
        v
      );
    if (colorish) return false;
  }
  if (low.includes('letra') && v.includes('/')) return false;
  if (low.includes(' - 100%')) return false;
  if (low.includes('azul/blanco')) return false;
  return true;
}

function isListableCatalogPrice(priceStr) {
  const n = parseFloat(priceStr);
  return Number.isFinite(n) && n > 1;
}

function vendorSearchUrl(vendor) {
  const root = window.Shopify?.routes?.root || '/';
  const q = `vendor:"${escapeFilterValue(vendor)}"`;
  return `${root}search?type=product&q=${encodeURIComponent(q)}`;
}

async function fetchCatalogVendors() {
  const vendors = new Set();
  let page = 1;
  for (;;) {
    const res = await fetch(`/collections/all/products.json?limit=250&page=${page}`, {
      credentials: 'same-origin',
    });
    if (!res.ok) break;
    const data = await res.json();
    const products = data.products || [];
    if (!products.length) break;
    products.forEach((product) => {
      const vendor = (product.vendor || '').trim();
      if (!vendor || !isPlausibleBrandName(vendor)) return;
      const variants = product.variants || [];
      const listable = variants.some((variant) => isListableCatalogPrice(variant.price));
      if (listable) vendors.add(vendor);
    });
    if (products.length < 250) break;
    page += 1;
  }
  return vendors;
}

async function hydrateBrandsFromCatalog() {
  const grid = document.querySelector('[data-brands-grid][data-brands-hydrate]');
  if (!grid) return;

  let logoMap = {};
  try {
    const mapEl = document.querySelector('[data-brands-logo-map]');
    if (mapEl) {
      JSON.parse(mapEl.textContent).forEach((row) => {
        if (row?.vendor && row.logo) logoMap[row.vendor] = row.logo;
      });
    }
  } catch {
    logoMap = {};
  }

  const catalogVendors = await fetchCatalogVendors();
  if (!catalogVendors.size) return;

  const existingItems = Array.from(grid.querySelectorAll('[data-brand-item]'));
  const existingNames = new Set();

  existingItems.forEach((item) => {
    const name = (item.getAttribute('data-brand-name') || '').trim();
    existingNames.add(name);
    if (!catalogVendors.has(name)) {
      item.dataset.brandRemoved = '1';
      item.hidden = true;
    } else {
      delete item.dataset.brandRemoved;
    }
  });

  Array.from(catalogVendors)
    .sort((a, b) => a.localeCompare(b, 'es'))
    .forEach((vendor) => {
      if (existingNames.has(vendor)) return;
      const li = document.createElement('li');
      li.className = 'brands-grid__item';
      li.setAttribute('data-brand-item', '');
      li.setAttribute('data-brand-name', vendor);

      const nameLen = vendor.length;
      let sizeClass = 'brand-card--m';
      if (nameLen > 22) sizeClass = 'brand-card--s';
      else if (nameLen < 10) sizeClass = 'brand-card--l';

      const link = document.createElement('a');
      link.href = vendorSearchUrl(vendor);
      link.className = `brand-card ${sizeClass}`;

      if (logoMap[vendor]) {
        const wrap = document.createElement('span');
        wrap.className = 'brand-card__logo-wrap';
        const img = document.createElement('img');
        img.className = 'brand-card__logo';
        img.loading = 'lazy';
        img.alt = vendor;
        img.src = logoMap[vendor];
        wrap.appendChild(img);
        link.appendChild(wrap);
      }

      const nameEl = document.createElement('span');
      nameEl.className = 'brand-card__name';
      nameEl.textContent = vendor;
      const cta = document.createElement('span');
      cta.className = 'brand-card__cta';
      cta.textContent = 'Ver catálogo';
      link.appendChild(nameEl);
      link.appendChild(cta);
      li.appendChild(link);
      grid.appendChild(li);
    });
}

function initFooterMobileAccordion() {
  const groups = Array.from(document.querySelectorAll('[data-footer-group]'));
  if (!groups.length) return;

  const mq = window.matchMedia('(max-width: 768px)');

  function syncFooterGroups() {
    groups.forEach((group) => {
      if (mq.matches) {
        if (group.hasAttribute('data-footer-social')) {
          group.setAttribute('open', '');
        } else {
          group.removeAttribute('open');
        }
      } else {
        group.setAttribute('open', '');
      }
    });
  }

  syncFooterGroups();
  mq.addEventListener('change', syncFooterGroups);
}

function highlightBrandMatch(name, query) {
  if (!query) return name;
  const idx = name.toLowerCase().indexOf(query.toLowerCase());
  if (idx < 0) return name;
  const before = name.slice(0, idx);
  const match = name.slice(idx, idx + query.length);
  const after = name.slice(idx + query.length);
  return `${before}<mark class="brands-match">${match}</mark>${after}`;
}

async function initBrandsPage() {
  const root = document.querySelector('[data-brands-search-root]');
  const input = document.querySelector('[data-brands-search-input]');
  const countEl = document.querySelector('[data-brands-count]');
  const predictive = document.querySelector('[data-brands-predictive]');
  const noResults = document.querySelector('[data-brands-no-results]');
  const grid = document.querySelector('[data-brands-grid]');
  const layout = document.querySelector('[data-brands-layout]');
  const indexList = document.querySelector('[data-brands-index-list]');
  if (!input) return;

  if (document.querySelector('[data-brands-hydrate]')) {
    await hydrateBrandsFromCatalog();
  }

  function brandName(item) {
    return (item.getAttribute('data-brand-name') || '').trim();
  }

  let items = Array.from(document.querySelectorAll('[data-brand-item]')).filter(
    (item) => !item.dataset.brandRemoved
  );
  if (!items.length) return;

  items.sort((a, b) =>
    brandName(a).localeCompare(brandName(b), 'es', { sensitivity: 'base' })
  );

  let total = items.length;
  const indexLinks = [];

  function brandUrl(item) {
    return item.querySelector('.brand-card')?.getAttribute('href') || '#';
  }

  function buildIndex() {
    if (!indexList || indexList.dataset.built) return;
    indexList.innerHTML = '';
    items.forEach((item) => {
      const a = document.createElement('a');
      a.className = 'brands-index__link';
      a.href = brandUrl(item);
      a.textContent = brandName(item);
      a.dataset.brandIndexFor = brandName(item);
      indexLinks.push({ link: a, item });
      indexList.appendChild(a);
    });
    indexList.dataset.built = '1';
  }

  buildIndex();

  function firstVisibleItem() {
    return items.find((item) => !item.hidden && !item.dataset.brandRemoved);
  }

  function applyFilter() {
    const q = input.value.trim().toLowerCase();
    let visible = 0;
    const matches = [];

    items = Array.from(document.querySelectorAll('[data-brand-item]'));
    items.forEach((item) => {
      const name = brandName(item);
      const inCatalog = !item.dataset.brandRemoved;
      const ok = inCatalog && (!q || name.toLowerCase().includes(q));
      item.hidden = !ok;
      if (ok) {
        visible += 1;
        matches.push(item);
      }
    });

    indexLinks.forEach(({ link, item }) => {
      const show = !item.hidden;
      link.hidden = !show;
      if (show && q) {
        link.innerHTML = highlightBrandMatch(brandName(item), q);
      } else if (show) {
        link.textContent = brandName(item);
      }
    });

    total = items.filter((item) => !item.dataset.brandRemoved).length;

    if (grid) {
      grid.classList.toggle('brands-grid--list', q.length > 0);
    }
    if (layout) {
      layout.classList.toggle('brands-page__layout--filtering', q.length > 0);
    }

    if (countEl) {
      countEl.textContent =
        q.length > 0 ? `${visible} de ${total} marcas` : `${total} marcas`;
    }

    if (noResults) {
      noResults.hidden = !(q.length > 0 && visible === 0);
    }

    if (!predictive) return;
    predictive.innerHTML = '';
    if (!q) {
      predictive.hidden = true;
      return;
    }

    matches.slice(0, 12).forEach((item) => {
      const li = document.createElement('li');
      li.className = 'brands-search__predictive-item';
      li.setAttribute('role', 'option');
      const a = document.createElement('a');
      a.className = 'brands-search__predictive-link';
      a.href = brandUrl(item);
      a.innerHTML = highlightBrandMatch(brandName(item), q);
      li.appendChild(a);
      predictive.appendChild(li);
    });
    predictive.hidden = matches.length === 0;
  }

  input.addEventListener('input', applyFilter);
  input.addEventListener('focus', () => {
    const q = input.value.trim();
    if (q && predictive && predictive.children.length) predictive.hidden = false;
  });
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      input.value = '';
      applyFilter();
      if (predictive) predictive.hidden = true;
      return;
    }
    if (e.key === 'Enter') {
      const first = firstVisibleItem();
      if (first) {
        window.location.href = brandUrl(first);
      }
    }
  });

  if (root) {
    document.addEventListener('click', (e) => {
      if (!root.contains(e.target) && predictive) predictive.hidden = true;
    });
  }

  applyFilter();
}

const OR_FILTER_INPUT_MAP = {
  'filter.p.product_type': 'product_type',
  'filter.p.vendor': 'vendor',
  'filter.p.tag': 'tag',
};

function escapeFilterValue(value) {
  return String(value || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"');
}

function parseFilterQuery(q) {
  const text = String(q || '').trim();
  const filters = [];
  if (!text) return { plain: '', filters };

  const orSegments = text.split(/\s+OR\s+/i).map((s) => s.trim()).filter(Boolean);
  if (orSegments.length > 1) {
    const orFilters = [];
    let orPlainParts = [];
    orSegments.forEach((segment) => {
      const filterMatch = segment.match(
        /^(product_type|vendor|tag|variant_option\.[a-z0-9_-]+):(?:"((?:\\.|[^"\\])*)"|([^\s"']+))$/i
      );
      if (filterMatch) {
        orFilters.push({
          key: filterMatch[1].toLowerCase(),
          value: (filterMatch[2] || filterMatch[3] || '').replace(/\\"/g, '"'),
        });
        return;
      }
      orPlainParts.push(segment);
    });
    const sameKey =
      orFilters.length > 0 && orFilters.every((f) => f.key === orFilters[0].key);
    if (sameKey && orPlainParts.length === 0) {
      return { plain: '', filters: orFilters };
    }
  }

  const re = /(product_type|vendor|tag|variant_option\.[a-z0-9_-]+):(?:"((?:\\.|[^"\\])*)"|([^\s"']+))/gi;
  let plain = text;
  const matches = [...text.matchAll(re)];
  matches.forEach((match) => {
    const key = match[1].toLowerCase();
    const rawValue = (match[2] || match[3] || '').replace(/\\"/g, '"');
    filters.push({ key, value: rawValue });
    plain = plain.replace(match[0], ' ');
  });

  plain = plain
    .replace(/\s+AND\s+/gi, ' ')
    .replace(/\s+OR\s+/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  return { plain, filters };
}

function serializeFilterQuery(plain, filters) {
  const parts = [];
  const keywords = String(plain || '').trim();
  if (keywords) parts.push(keywords);

  const grouped = new Map();
  (filters || []).forEach((filter) => {
    if (!filter?.key || !filter?.value) return;
    if (!grouped.has(filter.key)) grouped.set(filter.key, []);
    grouped.get(filter.key).push(filter);
  });

  grouped.forEach((group, key) => {
    const tokens = group.map((f) => `${key}:"${escapeFilterValue(f.value)}"`);
    if (key === 'product_type' && tokens.length > 1) {
      parts.push(tokens.join(' OR '));
    } else {
      parts.push(...tokens);
    }
  });

  return parts.join(' AND ');
}

function filtersFromForm(form) {
  const filters = [];
  form.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => {
    const name = input.name || '';
    const val = (input.value || '').trim();
    if (!val) return;
    const key = OR_FILTER_INPUT_MAP[name];
    if (key) {
      filters.push({ key, value: val });
      return;
    }
    if (name.startsWith('filter.v.option.')) {
      filters.push({
        key: `variant_option.${name.replace('filter.v.option.', '')}`,
        value: val,
      });
    }
  });
  return filters;
}

const OR_DEFAULT_SEARCH_SORT = 'relevance';

function buildSearchUrlFromState({ plain, filters, priceMin, priceMax, sortBy }) {
  const root = window.Shopify?.routes?.root || '/';
  const params = new URLSearchParams();
  params.set('type', 'product');
  const q = serializeFilterQuery(plain, filters);
  if (q) params.set('q', q);
  if (priceMin) params.set('filter.v.price.gte', priceMin);
  if (priceMax) params.set('filter.v.price.lte', priceMax);
  if (sortBy && sortBy !== OR_DEFAULT_SEARCH_SORT) params.set('sort_by', sortBy);
  return `${root}search?${params.toString()}`;
}

function normalizeFilterValue(value) {
  return String(value || '')
    .replace(/ > /g, ' / ')
    .replace(/>/g, ' / ')
    .trim();
}

/** Palabras + filtros en q: combina barra, checkboxes y URL actual. */
function resolveSearchFilterState(filterForm) {
  const params = new URLSearchParams(window.location.search);
  const parsed = parseFilterQuery(params.get('q') || '');
  const keywordsInput = document.querySelector('[data-or-search-keywords]');
  const plain = (keywordsInput?.value ?? parsed.plain ?? '').trim();
  const formFilters = filterForm ? filtersFromForm(filterForm) : [];
  const hasChecked = Boolean(filterForm?.querySelector('input[type="checkbox"]:checked'));
  const filters =
    hasChecked || formFilters.length > 0 ? formFilters : parsed.filters;
  const priceMin =
    filterForm?.querySelector('[name="filter.v.price.gte"]')?.value ||
    params.get('filter.v.price.gte') ||
    '';
  const priceMax =
    filterForm?.querySelector('[name="filter.v.price.lte"]')?.value ||
    params.get('filter.v.price.lte') ||
    '';
  const sortBy =
    filterForm?.querySelector('[name="sort_by"]')?.value ||
    params.get('sort_by') ||
    '';
  return { plain, filters, priceMin, priceMax, sortBy, parsed };
}

function navigateCollectionFilters(form) {
  if (!form || form.dataset.submitting === '1') return;
  form.dataset.submitting = '1';

  const { plain, filters, priceMin, priceMax, sortBy } = resolveSearchFilterState(form);

  const hasSomething = plain || filters.length || priceMin || priceMax;
  if (!hasSomething && form.dataset.collectionUrl) {
    window.location.href = form.dataset.collectionUrl;
    return;
  }

  window.location.href = buildSearchUrlFromState({
    plain,
    filters,
    priceMin,
    priceMax,
    sortBy,
  });
}

function categoryShortLabel(value) {
  const normalized = String(value || '')
    .replace(/ > /g, ' / ')
    .replace(/>/g, ' / ');
  const parts = normalized.split(' / ').map((p) => p.trim()).filter(Boolean);
  return parts.length > 1 ? parts[parts.length - 1] : normalized;
}

function filterLabel(filter) {
  const value = filter.value.replace(/ > /g, ' / ').replace(/>/g, ' / ');
  if (filter.key === 'product_type') return `Categoría: ${categoryShortLabel(value)}`;
  if (filter.key === 'vendor') return `Marca: ${value}`;
  if (filter.key === 'tag') return `Etiqueta: ${value}`;
  if (filter.key.startsWith('variant_option.')) {
    const opt = filter.key.replace('variant_option.', '').replace(/_/g, ' ');
    return `${opt}: ${filter.value}`;
  }
  return value;
}

function syncFilterCheckboxes(form, filters) {
  if (!form) return;
  form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
    const name = input.name || '';
    const val = (input.value || '').trim();
    let key = OR_FILTER_INPUT_MAP[name];
    if (!key && name.startsWith('filter.v.option.')) {
      key = `variant_option.${name.replace('filter.v.option.', '')}`;
    }
    if (!key) return;
    input.checked = filters.some(
      (f) =>
        f.key === key &&
        normalizeFilterValue(f.value) === normalizeFilterValue(val)
    );
  });
}

function renderActiveFilterChips() {
  const bar = document.querySelector('[data-or-filter-chips]');
  const list = document.querySelector('[data-or-filter-chips-list]');
  if (!bar || !list) return;

  const params = new URLSearchParams(window.location.search);
  const parsed = parseFilterQuery(params.get('q') || '');
  list.innerHTML = '';

  const priceMin = params.get('filter.v.price.gte');
  const priceMax = params.get('filter.v.price.lte');

  const sortBy = params.get('sort_by') || '';
  const hasSort = sortBy && sortBy !== OR_DEFAULT_SEARCH_SORT;

  if (!parsed.filters.length && !priceMin && !priceMax && !hasSort) {
    bar.hidden = true;
    return;
  }

  bar.hidden = false;

  parsed.filters.forEach((filter) => {
    const remaining = parsed.filters.filter(
      (f) => !(f.key === filter.key && f.value === filter.value)
    );
    const a = document.createElement('a');
    a.className = 'collection-active__chip';
    a.href = buildSearchUrlFromState({
      plain: parsed.plain,
      filters: remaining,
      priceMin: priceMin || '',
      priceMax: priceMax || '',
      sortBy,
    });
    a.innerHTML = `${filterLabel(filter)} <span class="collection-active__chip-x" aria-hidden="true">×</span>`;
    list.appendChild(a);
  });

  if (priceMin || priceMax) {
    const a = document.createElement('a');
    a.className = 'collection-active__chip';
    a.href = buildSearchUrlFromState({
      plain: parsed.plain,
      filters: parsed.filters,
      sortBy,
    });
    a.innerHTML = `Precio: ${priceMin || '0'} – ${priceMax || 'máx.'} <span class="collection-active__chip-x" aria-hidden="true">×</span>`;
    list.appendChild(a);
  }

  if (sortBy && sortBy !== OR_DEFAULT_SEARCH_SORT) {
    const sortLabels = {
      'price-ascending': 'Precio: menor a mayor',
      'price-descending': 'Precio: mayor a menor',
      'created-descending': 'Más recientes',
      'created-ascending': 'Más antiguos',
      'title-ascending': 'Nombre A–Z',
      'title-descending': 'Nombre Z–A',
      'best-selling': 'Más vendidos',
    };
    const a = document.createElement('a');
    a.className = 'collection-active__chip';
    a.href = buildSearchUrlFromState({
      plain: parsed.plain,
      filters: parsed.filters,
      priceMin: priceMin || '',
      priceMax: priceMax || '',
      sortBy: OR_DEFAULT_SEARCH_SORT,
    });
    a.innerHTML = `${sortLabels[sortBy] || 'Orden'} <span class="collection-active__chip-x" aria-hidden="true">×</span>`;
    list.appendChild(a);
  }

  const filterForm = document.querySelector('[data-collection-filters-form]');
  syncFilterCheckboxes(filterForm, parsed.filters);
  void refreshContextualVendorList(parsed);
  void refreshContextualTypeList(parsed);
  void refreshContextualVariantFilters(parsed);

  const keywordsInput = document.querySelector('[data-or-search-keywords]');
  if (keywordsInput) keywordsInput.value = parsed.plain || '';

  const sortSelect = document.querySelector('[data-or-search-sort]');
  if (sortSelect && sortBy) sortSelect.value = sortBy;
}

function syncSearchHeroTitle() {
  const heroTitle = document.querySelector('.search-page .product-page__hero-title');
  if (!heroTitle) return;
  const params = new URLSearchParams(window.location.search);
  const parsed = parseFilterQuery(params.get('q') || '');
  if (!parsed.filters.length && !parsed.plain) return;

  const vendor = parsed.filters.find((f) => f.key === 'vendor');
  const typeFilters = parsed.filters.filter((f) => f.key === 'product_type');
  const typeLabel = categoryFiltersGroupLabel(typeFilters);
  const parts = [];
  if (parsed.plain) parts.push(parsed.plain);
  if (vendor?.value) parts.push(vendor.value);
  if (typeLabel) parts.push(typeLabel);
  if (!parts.length) return;
  heroTitle.textContent = parts.join(' · ');

  const heroSub = document.querySelector('.search-page .product-page__hero-subtitle');
  if (heroSub && !parsed.plain) {
    if (vendor && typeFilters.length) heroSub.textContent = 'Marca · categoría';
    else if (vendor) heroSub.textContent = 'Marca';
    else if (typeFilters.length) heroSub.textContent = 'Categoría';
  }
}

function categoryFiltersGroupLabel(typeFilters) {
  if (!typeFilters?.length) return '';
  if (typeFilters.length === 1) return categoryShortLabel(typeFilters[0].value);
  const parents = new Set(
    typeFilters.map((f) => {
      const normalized = normalizeFilterValue(f.value);
      return normalized.split(' / ')[0].trim();
    })
  );
  if (parents.size === 1) return [...parents][0];
  return typeFilters.map((f) => categoryShortLabel(f.value)).join(', ');
}

function redirectBareSearchToCatalog() {
  if (!document.querySelector('[data-or-search-keywords]')) return;
  const params = new URLSearchParams(window.location.search);
  const q = (params.get('q') || '').trim();
  const priceMin = params.get('filter.v.price.gte');
  const priceMax = params.get('filter.v.price.lte');
  if (q || priceMin || priceMax) return;
  const catalog =
    document.querySelector('[data-or-filter-clear-all]')?.getAttribute('href') ||
    document.querySelector('[data-collection-filters-form]')?.dataset.collectionUrl;
  if (catalog && window.location.pathname.includes('/search')) {
    window.location.replace(catalog);
  }
}

function initSearchFilterUi() {
  redirectBareSearchToCatalog();
  renderActiveFilterChips();
  syncSearchHeroTitle();

  const searchBarForm = document.querySelector('[data-or-search-bar-form]');
  if (searchBarForm) {
    searchBarForm.addEventListener('submit', (event) => {
      event.preventDefault();
      const filterForm = document.querySelector('[data-collection-filters-form]');
      const { plain, filters, priceMin, priceMax, sortBy } = resolveSearchFilterState(filterForm);
      window.location.href = buildSearchUrlFromState({
        plain,
        filters,
        priceMin,
        priceMax,
        sortBy,
      });
    });
  }

  document.querySelectorAll('.collection-toolbar__sort select').forEach((sortSelect) => {
    if (!document.querySelector('[data-or-search-keywords]')) return;
    sortSelect.addEventListener('change', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const filterForm = document.querySelector('[data-collection-filters-form]');
      const { plain, filters, priceMin, priceMax } = resolveSearchFilterState(filterForm);
      window.location.href = buildSearchUrlFromState({
        plain,
        filters,
        priceMin,
        priceMax,
        sortBy: sortSelect.value,
      });
    });
  });
}

function bindFilterFormCheckboxes(filterForm) {
  if (!filterForm) return;
  filterForm.querySelectorAll('input[type="checkbox"]').forEach((input) => {
    if (input.dataset.orFilterBound === '1') return;
    input.dataset.orFilterBound = '1';
    input.addEventListener('change', () => {
      navigateCollectionFilters(filterForm);
    });
  });
}

async function fetchAllCatalogProducts() {
  const products = [];
  let page = 1;
  for (;;) {
    const res = await fetch(`/collections/all/products.json?limit=250&page=${page}`, {
      credentials: 'same-origin',
    });
    if (!res.ok) break;
    const data = await res.json();
    const batch = data.products || [];
    if (!batch.length) break;
    products.push(...batch);
    if (batch.length < 250) break;
    page += 1;
  }
  return products;
}

function isListableProduct(product) {
  const variants = product.variants || [];
  return variants.some((v) => isListableCatalogPrice(v.price));
}

function shopifyHandle(str) {
  return String(str || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function productMatchesVariantFilters(product, variantFilters) {
  if (!variantFilters.length) return true;
  const variants = product.variants || [];
  const options = product.options || [];
  return variantFilters.every((vf) => {
    const optHandle = vf.key.replace('variant_option.', '');
    return variants.some((variant) =>
      options.some((opt, index) => {
        if (shopifyHandle(opt.name) !== optHandle) return false;
        const val = String(variant[`option${index + 1}`] || '').trim();
        return val === vf.value;
      })
    );
  });
}

function productsMatchingFilters(products, parsed) {
  const typeFilters = (parsed?.filters || []).filter((f) => f.key === 'product_type');
  const vendorFilters = (parsed?.filters || []).filter((f) => f.key === 'vendor');
  const variantFilters = (parsed?.filters || []).filter((f) =>
    f.key.startsWith('variant_option.')
  );
  let list = products.filter((p) => isListableProduct(p));

  if (vendorFilters.length) {
    list = list.filter((product) =>
      vendorFilters.every((vf) => (product.vendor || '').trim() === vf.value)
    );
  }
  if (typeFilters.length) {
    list = list.filter((product) => {
      const pt = normalizeFilterValue(product.product_type || '');
      return typeFilters.some(
        (tf) => pt === normalizeFilterValue(tf.value)
      );
    });
  }
  if (variantFilters.length) {
    list = list.filter((product) => productMatchesVariantFilters(product, variantFilters));
  }
  return list;
}

function variantOptionsFromProducts(products) {
  const optionsMap = new Map();
  products.forEach((product) => {
    if (!isListableProduct(product)) return;
    const optDefs = product.options || [];
    optDefs.forEach((opt) => {
      const name = (opt.name || '').trim();
      if (!name || /^title$/i.test(name)) return;
      if (!optionsMap.has(name)) optionsMap.set(name, new Set());
      (opt.values || []).forEach((value) => {
        const val = String(value || '').trim();
        if (val && !/^default title$/i.test(val)) optionsMap.get(name).add(val);
      });
    });
    (product.variants || []).forEach((variant) => {
      optDefs.forEach((opt, index) => {
        const name = (opt.name || '').trim();
        if (!name || /^title$/i.test(name)) return;
        const val = String(variant[`option${index + 1}`] || '').trim();
        if (!val || /^default title$/i.test(val)) return;
        if (!optionsMap.has(name)) optionsMap.set(name, new Set());
        optionsMap.get(name).add(val);
      });
    });
  });
  return optionsMap;
}

function vendorsFromProducts(products) {
  const vendors = new Set();
  products.forEach((product) => {
    const vendor = (product.vendor || '').trim();
    if (vendor && isPlausibleBrandName(vendor)) vendors.add(vendor);
  });
  return Array.from(vendors).sort((a, b) => a.localeCompare(b, 'es'));
}

function typesFromProducts(products) {
  const types = new Map();
  products.forEach((product) => {
    if (!isListableProduct(product)) return;
    const type = (product.product_type || '').trim();
    if (type) types.set(type, type);
  });
  return Array.from(types.keys()).sort((a, b) => a.localeCompare(b, 'es'));
}

let orCatalogProductsCache = null;

async function getCatalogProducts() {
  if (orCatalogProductsCache) return orCatalogProductsCache;
  orCatalogProductsCache = await fetchAllCatalogProducts();
  return orCatalogProductsCache;
}

function typeLabels(typeValue) {
  const label = String(typeValue || '')
    .replace(/ > /g, ' / ')
    .replace(/>/g, ' / ');
  const parts = label.split(' / ').map((p) => p.trim()).filter(Boolean);
  const short = parts.length > 1 ? parts[parts.length - 1] : label;
  const key = `${label} ${short}`.toLowerCase();
  return { label, short, parts, key };
}

function appendVendorFilterItem(list, vendor, activeVendors) {
  const li = document.createElement('li');
  li.className = 'collection-filter__item';
  li.setAttribute('data-filter-item', '');
  li.setAttribute('data-filter-search-key', vendor.toLowerCase());
  const label = document.createElement('label');
  label.className = 'collection-filter__check';
  const input = document.createElement('input');
  input.type = 'checkbox';
  input.name = 'filter.p.vendor';
  input.value = vendor;
  if (activeVendors.has(vendor)) input.checked = true;
  const span = document.createElement('span');
  span.className = 'collection-filter__check-text';
  span.setAttribute('data-filter-label', '');
  span.textContent = vendor;
  label.appendChild(input);
  label.appendChild(span);
  li.appendChild(label);
  list.appendChild(li);
}

function appendTypeFilterItem(list, typeValue, activeTypes) {
  const { label, short, parts, key } = typeLabels(typeValue);
  const li = document.createElement('li');
  li.className = 'collection-filter__item';
  li.setAttribute('data-filter-item', '');
  li.setAttribute('data-filter-search-key', key);
  const wrap = document.createElement('label');
  wrap.className = 'collection-filter__check';
  const input = document.createElement('input');
  input.type = 'checkbox';
  input.name = 'filter.p.product_type';
  input.value = typeValue;
  if (activeTypes.has(typeValue)) input.checked = true;
  const text = document.createElement('span');
  text.className = 'collection-filter__check-text';
  text.setAttribute('data-filter-label', '');
  text.title = label;
  if (parts.length > 1) {
    const shortEl = document.createElement('span');
    shortEl.className = 'collection-filter__check-short';
    shortEl.textContent = short;
    const pathEl = document.createElement('span');
    pathEl.className = 'collection-filter__check-path';
    pathEl.textContent = label;
    text.appendChild(shortEl);
    text.appendChild(pathEl);
  } else {
    text.textContent = label;
  }
  wrap.appendChild(input);
  wrap.appendChild(text);
  li.appendChild(wrap);
  list.appendChild(li);
}

async function refreshContextualVendorList(parsed) {
  const vendorList = document.querySelector('[data-or-vendor-list]');
  if (!vendorList) return;
  const products = await getCatalogProducts();
  if (!products.length) return;

  const scoped = productsMatchingFilters(products, parsed);
  const vendors = vendorsFromProducts(scoped);
  const activeVendors = new Set(
    (parsed?.filters || []).filter((f) => f.key === 'vendor').map((f) => f.value)
  );

  vendorList.innerHTML = '';
  vendors.forEach((vendor) => appendVendorFilterItem(vendorList, vendor, activeVendors));

  const hint = document.querySelector('[data-or-vendor-scope-hint]');
  if (hint) {
    const typeFilters = (parsed?.filters || []).filter((f) => f.key === 'product_type');
    const vendorFilters = (parsed?.filters || []).filter((f) => f.key === 'vendor');
    if (typeFilters.length) {
      hint.textContent = `${vendors.length} marcas en esta categoría`;
      hint.hidden = false;
    } else if (vendorFilters.length && vendors.length <= 1) {
      hint.hidden = true;
    } else {
      hint.hidden = true;
    }
  }

  const filterForm = document.querySelector('[data-collection-filters-form]');
  bindFilterFormCheckboxes(filterForm);
  syncFilterCheckboxes(filterForm, parsed?.filters || []);

  const marcaInput = document.querySelector('[data-filter-group="marca"] [data-filter-search-input]');
  if (marcaInput) marcaInput.dispatchEvent(new Event('input', { bubbles: true }));
  applyFilterListPreview();
  openFilterSectionsWithSelection();
}

function appendVariantFilterItem(list, paramName, value, checked) {
  const li = document.createElement('li');
  li.className = 'collection-filter__item';
  li.setAttribute('data-filter-item', '');
  li.setAttribute('data-filter-search-key', value.toLowerCase());
  const label = document.createElement('label');
  label.className = 'collection-filter__check';
  const input = document.createElement('input');
  input.type = 'checkbox';
  input.name = paramName;
  input.value = value;
  if (checked) input.checked = true;
  const span = document.createElement('span');
  span.className = 'collection-filter__check-text';
  span.setAttribute('data-filter-label', '');
  span.textContent = value;
  label.appendChild(input);
  label.appendChild(span);
  li.appendChild(label);
  list.appendChild(li);
}

async function refreshContextualVariantFilters(parsed) {
  const root = document.querySelector('[data-or-variant-filters-root]');
  if (!root) return;
  const products = await getCatalogProducts();
  if (!products.length) {
    root.innerHTML = '';
    return;
  }

  const parsedScope = {
    plain: parsed?.plain || '',
    filters: (parsed?.filters || []).filter((f) => !f.key.startsWith('variant_option.')),
  };
  const scoped = productsMatchingFilters(products, parsedScope);
  const optionsMap = variantOptionsFromProducts(scoped);
  const activeVariantKeys = new Set(
    (parsed?.filters || [])
      .filter((f) => f.key.startsWith('variant_option.'))
      .map((f) => `${f.key}::${f.value}`)
  );

  root.innerHTML = '';

  Array.from(optionsMap.entries())
    .sort(([a], [b]) => a.localeCompare(b, 'es'))
    .forEach(([optName, valuesSet]) => {
      const values = Array.from(valuesSet).sort((a, b) => a.localeCompare(b, 'es'));
      if (!values.length) return;
      const handle = shopifyHandle(optName);
      const paramName = `filter.v.option.${handle}`;
      const variantKeyPrefix = `variant_option.${handle}`;

      const details = document.createElement('details');
      details.className = 'collection-filter collection-filter--searchable';
      details.open = false;
      details.setAttribute('data-filter-group', `variante-${handle}`);

      const summary = document.createElement('summary');
      summary.className = 'collection-filter__label';
      summary.textContent = optName;
      details.appendChild(summary);

      const body = document.createElement('div');
      body.className = 'collection-filter__body';

      if (values.length > 3) {
        const searchWrap = document.createElement('div');
        searchWrap.className = 'collection-filter__search';
        searchWrap.setAttribute('data-filter-search-root', '');
        const searchInput = document.createElement('input');
        searchInput.type = 'search';
        searchInput.className = 'collection-filter__search-input';
        searchInput.placeholder = 'Buscar…';
        searchInput.autocomplete = 'off';
        searchInput.setAttribute('data-filter-search-input', '');
        searchWrap.appendChild(searchInput);
        const predictive = document.createElement('ul');
        predictive.className = 'collection-filter__predictive';
        predictive.setAttribute('data-filter-search-predictive', '');
        predictive.hidden = true;
        searchWrap.appendChild(predictive);
        body.appendChild(searchWrap);
      }

      const list = document.createElement('ul');
      list.className = 'collection-filter__list';
      list.setAttribute('role', 'list');
      list.setAttribute('data-filter-search-list', '');
      values.forEach((val) => {
        const checked = activeVariantKeys.has(`${variantKeyPrefix}::${val}`);
        appendVariantFilterItem(list, paramName, val, checked);
      });
      body.appendChild(list);
      details.appendChild(body);
      root.appendChild(details);
    });

  const filterForm = document.querySelector('[data-collection-filters-form]');
  bindFilterFormCheckboxes(filterForm);
  initCollectionFilterSearch();
  applyFilterListPreview(document.querySelector('[data-or-variant-filters-root]') || document);
  openFilterSectionsWithSelection();
}

async function refreshContextualTypeList(parsed) {
  const typeList = document.querySelector('[data-or-type-list]');
  if (!typeList) return;
  const products = await getCatalogProducts();
  if (!products.length) return;

  const scoped = productsMatchingFilters(products, parsed);
  const types = typesFromProducts(scoped);
  const activeTypes = new Set(
    (parsed?.filters || []).filter((f) => f.key === 'product_type').map((f) => f.value)
  );

  typeList.innerHTML = '';
  types.forEach((typeValue) => appendTypeFilterItem(typeList, typeValue, activeTypes));

  const hint = document.querySelector('[data-or-type-scope-hint]');
  if (hint) {
    const vendorFilters = (parsed?.filters || []).filter((f) => f.key === 'vendor');
    if (vendorFilters.length) {
      hint.textContent = `${types.length} categorías de esta marca`;
      hint.hidden = false;
    } else {
      hint.hidden = true;
    }
  }

  const filterForm = document.querySelector('[data-collection-filters-form]');
  bindFilterFormCheckboxes(filterForm);
  syncFilterCheckboxes(filterForm, parsed?.filters || []);

  const catInput = document.querySelector('[data-filter-group="categoria"] [data-filter-search-input]');
  if (catInput) catInput.dispatchEvent(new Event('input', { bubbles: true }));
  applyFilterListPreview();
  openFilterSectionsWithSelection();
}

async function hydrateCatalogFilterLists() {
  const vendorList = document.querySelector('[data-or-vendor-list]');
  const typeList = document.querySelector('[data-or-type-list]');
  if (!vendorList && !typeList) return;

  const params = new URLSearchParams(window.location.search);
  const parsed = parseFilterQuery(params.get('q') || '');

  if (vendorList) {
    await refreshContextualVendorList(parsed);
  }

  if (typeList) {
    await refreshContextualTypeList(parsed);
  }

  await refreshContextualVariantFilters(parsed);

  const filterForm = document.querySelector('[data-collection-filters-form]');
  bindFilterFormCheckboxes(filterForm);
  syncFilterCheckboxes(filterForm, parsed.filters);
  initCollectionFilterSearch();
  applyFilterListPreview();
  openFilterSectionsWithSelection();
}

async function initCollectionFilters() {
  document.querySelectorAll('.collection-toolbar__sort select').forEach((sortSelect) => {
    if (document.querySelector('[data-or-search-keywords]')) return;
    const formId = sortSelect.getAttribute('form');
    const sortForm = formId ? document.getElementById(formId) : null;
    if (sortForm) {
      sortSelect.addEventListener('change', () => {
        sortForm.submit();
      });
    }
  });

  const filterForm = document.querySelector('[data-collection-filters-form]');
  if (filterForm) {
    filterForm.addEventListener('submit', (event) => {
      if (filterForm.dataset.filterViaSearch !== 'true') return;
      event.preventDefault();
      navigateCollectionFilters(filterForm);
    });
    bindFilterFormCheckboxes(filterForm);
  }

  await hydrateCatalogFilterLists();
  initSearchFilterUi();
}

const OR_FILTER_LIST_PREVIEW = 6;

function applyFilterListPreview(scope = document) {
  scope.querySelectorAll('[data-filter-search-list]').forEach((list) => {
    const items = () => Array.from(list.querySelectorAll(':scope > [data-filter-item]'));
    const count = items().length;
    if (count > 10) list.classList.add('collection-filter__list--scroll');

    let btn = list.parentElement?.querySelector('[data-or-filter-expand]');
    if (count <= OR_FILTER_LIST_PREVIEW) {
      if (btn) btn.remove();
      items().forEach((item) => item.classList.remove('or-filter-item--preview-hidden'));
      return;
    }

    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'collection-filter__expand';
      btn.setAttribute('data-or-filter-expand', '');
      list.insertAdjacentElement('afterend', btn);
    }

    const refresh = () => {
      const expanded = list.dataset.orExpanded === '1';
      const all = items();
      all.forEach((item, index) => {
        const checked = item.querySelector('input[type="checkbox"]:checked');
        const hide = !expanded && index >= OR_FILTER_LIST_PREVIEW && !checked;
        item.classList.toggle('or-filter-item--preview-hidden', hide);
      });
      const hiddenCount = all.filter((item, index) => {
        const checked = item.querySelector('input[type="checkbox"]:checked');
        return !expanded && index >= OR_FILTER_LIST_PREVIEW && !checked;
      }).length;
      btn.textContent = expanded ? 'Ver menos' : `Ver más (${hiddenCount})`;
      btn.hidden = expanded ? false : hiddenCount === 0;
    };

    if (!btn.dataset.orBound) {
      btn.dataset.orBound = '1';
      btn.addEventListener('click', () => {
        list.dataset.orExpanded = list.dataset.orExpanded === '1' ? '' : '1';
        refresh();
      });
    }
    refresh();
  });
}

function openFilterSectionsWithSelection() {
  document.querySelectorAll('.collection-filters details.collection-filter').forEach((details) => {
    const hasChecked = details.querySelector('input[type="checkbox"]:checked');
    if (hasChecked) details.open = true;
  });
}

function initCollectionFilterSearch() {
  document.querySelectorAll('[data-filter-search-root]').forEach((root) => {
    if (root.dataset.orSearchBound === '1') return;
    root.dataset.orSearchBound = '1';
    const input = root.querySelector('[data-filter-search-input]');
    const predictive = root.querySelector('[data-filter-search-predictive]');
    const filterBody = root.closest('.collection-filter__body');
    const list = filterBody?.querySelector('[data-filter-search-list]');
    if (!input || !list) return;

    let hint = filterBody.querySelector('.collection-filter__empty-hint');
    if (!hint) {
      hint = document.createElement('p');
      hint.className = 'collection-filter__empty-hint';
      hint.textContent = 'Ningún resultado. Prueba otro término.';
      list.insertAdjacentElement('afterend', hint);
    }

    const items = () => Array.from(list.querySelectorAll('[data-filter-item]'));

    function normalizeSearchText(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();
    }

    function labelText(item) {
      const searchKey = item.getAttribute('data-filter-search-key');
      if (searchKey) return searchKey;
      const labelEl = item.querySelector('[data-filter-label]');
      return (labelEl?.textContent || '').replace(/\s*\(\d+\)\s*$/, '').trim();
    }

    function applyFilter(query) {
      const q = normalizeSearchText(query);
      let visible = 0;
      items().forEach((item) => {
        const text = normalizeSearchText(labelText(item));
        const match = !q || text.includes(q);
        item.hidden = !match;
        item.style.display = match ? '' : 'none';
        if (match) visible += 1;
      });
      hint.classList.toggle('is-visible', q.length > 0 && visible === 0);
      return { q, visible };
    }

    function renderPredictive(matches) {
      if (!predictive) return;
      predictive.innerHTML = '';
      if (!matches.length) {
        predictive.hidden = true;
        return;
      }
      matches.slice(0, 8).forEach((item, index) => {
        const li = document.createElement('li');
        li.className = 'collection-filter__predictive-item';
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'collection-filter__predictive-btn' + (index === 0 ? ' is-highlighted' : '');
        btn.textContent = labelText(item);
        btn.addEventListener('click', () => {
          const checkbox = item.querySelector('input[type="checkbox"]');
          if (checkbox && !checkbox.disabled) {
            checkbox.checked = true;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
          }
          input.value = '';
          applyFilter('');
          predictive.hidden = true;
        });
        li.appendChild(btn);
        predictive.appendChild(li);
      });
      predictive.hidden = false;
    }

    input.addEventListener('input', () => {
      const { q } = applyFilter(input.value);
      if (q.length >= 1) {
        const matches = items().filter((item) => !item.hidden);
        renderPredictive(matches.length ? matches : []);
      } else if (predictive) {
        predictive.hidden = true;
      }
    });

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
      }
      if (e.key === 'Escape') {
        input.value = '';
        applyFilter('');
        if (predictive) predictive.hidden = true;
      }
    });

    input.addEventListener('click', (e) => {
      e.stopPropagation();
    });

    document.addEventListener('click', (e) => {
      if (!root.contains(e.target)) {
        if (predictive) predictive.hidden = true;
      }
    });

    applyFilter('');
  });
}

function initCartPage() {
  const root = document.querySelector('[data-cart-page]');
  if (!root) return;

  async function changeLineQuantity(lineKey, quantity) {
    const qty = Math.max(0, quantity);
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id: lineKey, quantity: qty }),
      });
      if (!res.ok) throw new Error('Cart update failed');
      window.location.reload();
    } catch {
      window.location.reload();
    }
  }

  root.querySelectorAll('[data-cart-qty-minus]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const key = btn.dataset.lineKey;
      const current = parseInt(btn.dataset.quantity, 10) || 0;
      changeLineQuantity(key, current - 1);
    });
  });

  root.querySelectorAll('[data-cart-qty-plus]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const key = btn.dataset.lineKey;
      const current = parseInt(btn.dataset.quantity, 10) || 0;
      changeLineQuantity(key, current + 1);
    });
  });
}

function isListablePriceCents(cents) {
  const value = Number(cents);
  if (!Number.isFinite(value)) return false;
  return value > 100;
}

function initProductPage() {
  productGalleryApi = initProductGallery();

  const jsonEl = document.querySelector('[data-product-json]');
  const form = document.querySelector('[data-product-form]');
  if (!jsonEl || !form) return;

  let product;
  try {
    product = JSON.parse(jsonEl.textContent);
  } catch {
    return;
  }

  const idInput = form.querySelector('[data-product-variant-id]');
  const priceEl = document.querySelector('[data-product-price]');
  const variantTitleEl = document.querySelector('[data-product-variant-title]');
  const skuEl = document.querySelector('.product-page__sku');
  const submitBtn = form.querySelector('[data-product-add-btn]');
  const waBtn = document.querySelector('[data-product-wa-btn]');
  function normalizeWaPhone(phone) {
    const digits = String(phone || '573193313429').replace(/\D/g, '');
    return digits || '573193313429';
  }
  const waPhone = normalizeWaPhone(
    document.querySelector('.product-page')?.getAttribute('data-wa-phone')
  );
  const selects = form.querySelectorAll('[data-product-option]');
  const optionPills = form.querySelectorAll('[data-product-option-pill]');
  const variantPicker = form.querySelector('[data-product-variant-picker]');
  const currency =
    document.querySelector('.product-page')?.getAttribute('data-shop-currency') || 'COP';

  function formatPrice(cents) {
    const amount = cents / 100;
    try {
      return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 0,
      }).format(amount);
    } catch {
      return `$${Math.round(amount).toLocaleString('es-CO')}`;
    }
  }

  function selectedOptions() {
    return Array.from(selects).map((select) => select.value);
  }

  function findVariant() {
    if (variantPicker) {
      return product.variants.find((v) => String(v.id) === String(variantPicker.value));
    }
    const opts = selectedOptions();
    return product.variants.find((variant) =>
      variant.options.every((option, index) => option === opts[index])
    );
  }

  function syncOptionPills() {
    optionPills.forEach((pill) => {
      const index = parseInt(pill.dataset.optionIndex, 10);
      const select = selects[index];
      const isSelected = select && select.value === pill.dataset.optionValue;
      pill.classList.toggle('is-selected', isSelected);
    });
  }

  let variantImageMap = [];
  try {
    const mapEl = document.querySelector('[data-product-variant-images]');
    if (mapEl) variantImageMap = JSON.parse(mapEl.textContent);
  } catch {
    variantImageMap = [];
  }

  const galleryItems = productGalleryApi?.items || [];

  function variantIndex(variant) {
    if (!variant) return -1;
    return product.variants.findIndex((v) => v.id === variant.id);
  }

  function normalizeText(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  }

  function galleryItemForVariant(variant) {
    if (!variant) return null;
    const variantKey = String(variant.id);

    const byVariantIds = galleryItems.find((item) =>
      (item.variant_ids || []).some((vid) => String(vid) === variantKey)
    );
    if (byVariantIds) return byVariantIds;

    const productImages = product.images || [];
    const linkedImage = productImages.find((img) =>
      Array.isArray(img.variant_ids) &&
      img.variant_ids.some((vid) => String(vid) === variantKey)
    );
    if (linkedImage) {
      const fromGallery = galleryItems.find((item) => String(item.id) === String(linkedImage.id));
      if (fromGallery) return fromGallery;
      if (linkedImage.src) {
        return {
          id: linkedImage.id,
          src: linkedImage.src,
          alt: linkedImage.alt || '',
          variant_ids: linkedImage.variant_ids || [],
        };
      }
    }

    const mapped = variantImageMap.find((row) => String(row.variant_id) === variantKey);
    const candidateIds = [
      mapped?.image_id,
      mapped?.featured_media_id,
      mapped?.media_id,
      variant.image_id,
      variant.featured_image?.id,
      variant.featured_media?.id,
    ].filter((id) => id != null);

    for (const mediaId of candidateIds) {
      const fromGallery = galleryItems.find((item) => String(item.id) === String(mediaId));
      if (fromGallery) return fromGallery;
    }

    if (variant.featured_image?.src) {
      return {
        id: variant.featured_image.id,
        src: variant.featured_image.src,
        alt: variant.featured_image.alt || '',
        variant_ids: [variant.id],
      };
    }

    const options = mapped?.options || variant.options || [];
    for (const opt of options) {
      if (!opt) continue;
      const needle = normalizeText(opt);
      const byMeta = galleryItems.find((item) => {
        const alt = normalizeText(item.alt);
        const src = normalizeText(item.src);
        return alt.includes(needle) || src.includes(needle);
      });
      if (byMeta) return byMeta;
    }

    const idx = variantIndex(variant);
    if (idx >= 0 && galleryItems[idx]) {
      return galleryItems[idx];
    }

    return null;
  }

  function resolveVariantMedia(variant) {
    const item = galleryItemForVariant(variant);
    if (!item) return null;
    return {
      id: item.id,
      src: item.src,
      alt: item.alt || '',
      variantId: variant.id,
    };
  }

  function setMainProductImage(src, alt, mediaId, variantId) {
    if (!src) return;
    if (productGalleryApi) {
      productGalleryApi.showImage(src, alt || '', mediaId, false, variantId);
      return;
    }
    const mainImg =
      document.querySelector('[data-product-gallery] .product-page__product-img') ||
      document.querySelector('#ProductPageImage') ||
      document.querySelector('[data-product-gallery-main]');
    if (!mainImg) return;
    mainImg.removeAttribute('srcset');
    mainImg.removeAttribute('sizes');
    mainImg.src = normalizeProductImageSrc(src);
    if (alt) mainImg.alt = alt;
  }

  function showVariantImage(variant) {
    if (!variant) return;

    const idx = variantIndex(variant);
    const mapped = variantImageMap.find((row) => String(row.variant_id) === String(variant.id));

    if (mapped?.image_src) {
      setMainProductImage(mapped.image_src, mapped.alt || '', mapped.image_id, variant.id);
      return;
    }

    if (idx >= 0 && galleryItems[idx]?.src) {
      const item = galleryItems[idx];
      setMainProductImage(item.preview || item.src, item.alt || '', item.id, variant.id);
      return;
    }

    const media = resolveVariantMedia(variant);
    if (media?.src) {
      setMainProductImage(media.src, media.alt, media.id, media.variantId);
    }
  }

  async function fetchVariantImage(variant) {
    if (!variant) return;
    try {
      const res = await fetch(`${window.location.pathname}.js`, { credentials: 'same-origin' });
      if (!res.ok) return;
      const data = await res.json();
      const idx = data.variants.findIndex((v) => v.id === variant.id);
      const fresh = data.variants[idx];
      const img = fresh?.featured_image || data.images?.[idx];
      if (img?.src) {
        setMainProductImage(img.src, img.alt || '', img.id, variant.id);
      }
    } catch {
      /* ignore */
    }
  }

  function applyVariant(variant) {
    if (!variant) return;
    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = formatPrice(variant.price);
    if (variantTitleEl) {
      if (variant.title && variant.title !== 'Default Title') {
        variantTitleEl.textContent = variant.title;
        variantTitleEl.hidden = false;
      } else {
        variantTitleEl.hidden = true;
      }
    }
    if (skuEl) {
      if (variant.sku) {
        skuEl.textContent = `SKU ${variant.sku}`;
        skuEl.hidden = false;
      } else {
        skuEl.hidden = true;
      }
    }
    function encargoWhatsAppUrl(variant) {
      let name = product.title || '';
      if (variant?.title && variant.title !== 'Default Title') {
        name = `${name} (${variant.title})`;
      }
      const msg = `Hola, me interesa el producto: ${name}. ¿Lo tienen disponible por encargo? Gracias.`;
      return `https://api.whatsapp.com/send?phone=${waPhone}&text=${encodeURIComponent(msg)}`;
    }

    const qty = typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : null;
    const canBuy = Boolean(variant.available) && (qty === null || qty > 0);

    if (submitBtn) {
      submitBtn.hidden = !canBuy;
      if (canBuy && submitBtn.dataset.labelAvailable) {
        submitBtn.textContent = submitBtn.dataset.labelAvailable;
      }
    }
    if (waBtn) {
      waBtn.hidden = canBuy;
      waBtn.href = encargoWhatsAppUrl(variant);
    }
    showVariantImage(variant);
  }

  if (submitBtn && !submitBtn.dataset.labelAvailable) {
    submitBtn.dataset.labelAvailable = submitBtn.textContent.trim();
  }

  selects.forEach((select) => {
    select.addEventListener('change', () => {
      syncOptionPills();
      const optionWrap = select.closest('.product-page__option--select');
      if (optionWrap) {
        const currentEl = optionWrap.querySelector('.product-page__option-current');
        const label =
          select.options[select.selectedIndex]?.textContent?.trim() || select.value || '';
        if (currentEl) currentEl.textContent = label;
      }
      const variant = findVariant();
      applyVariant(variant);
      void fetchVariantImage(variant);
    });
  });

  optionPills.forEach((pill) => {
    pill.addEventListener('click', () => {
      const index = parseInt(pill.dataset.optionIndex, 10);
      const select = selects[index];
      if (!select) return;
      select.value = pill.dataset.optionValue || '';
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  if (variantPicker) {
    variantPicker.addEventListener('change', () => {
      const variant = findVariant();
      applyVariant(variant);
      void fetchVariantImage(variant);
    });
  }

  syncOptionPills();
  applyVariant(findVariant());
}

function initProductRelated() {
  const root = document.querySelector('[data-product-related]');
  if (!root) return;

  const track = root.querySelector('[data-product-related-track]');
  const slider = root.querySelector('[data-product-related-slider]');
  const loadingEl = root.querySelector('[data-product-related-loading]');
  const emptyEl = root.querySelector('[data-product-related-empty]');
  const moreLink = root.querySelector('[data-product-related-more]');
  const prevBtn = root.querySelector('[data-product-related-prev]');
  const nextBtn = root.querySelector('[data-product-related-next]');
  const metaEl = root.querySelector('[data-product-related-meta]');
  if (!track || !metaEl) return;

  let meta = {};
  try {
    meta = JSON.parse(metaEl.textContent);
  } catch {
    return;
  }

  const productId = Number(meta.productId || root.dataset.productId);
  const limit = Math.min(20, Math.max(4, Number(meta.limit || root.dataset.limit || 10)));
  const recommendationsUrl = root.dataset.recommendationsUrl;
  const rootPath = window.Shopify?.routes?.root || '/';

  function formatMoney(cents) {
    const amount = Number(cents);
    if (!Number.isFinite(amount)) return '';
    if (typeof window.Shopify?.formatMoney === 'function') {
      return window.Shopify.formatMoney(amount, meta.moneyFormat);
    }
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      maximumFractionDigits: 0,
    }).format(amount / 100);
  }

  function categoryQueries() {
    const queries = [];
    const seen = new Set();
    const push = (value) => {
      const q = String(value || '').trim();
      if (!q || seen.has(q.toLowerCase())) return;
      seen.add(q.toLowerCase());
      queries.push(q);
    };

    const type = meta.productType || '';
    if (type) {
      push(type);
      type.split(/\s*[>|/]\s*/).forEach((part) => push(part));
    }

    const tags = Array.isArray(meta.tags) ? meta.tags : [];
    tags.slice().reverse().forEach((tag) => push(tag));

    if (type.includes(' ') || type.includes('>') || type.includes('/')) {
      push(`product_type:"${type}"`);
    } else if (type) {
      push(`product_type:${type}`);
    }
    tags.forEach((tag) => push(`tag:${tag}`));

    return queries;
  }

  function productHandle(url) {
    return url?.match(/\/products\/([^/?#]+)/)?.[1] || null;
  }

  function normalizeImageUrl(raw) {
    if (!raw) return null;
    let url = typeof raw === 'string' ? raw : raw.src || raw.url || '';
    url = String(url).trim();
    if (!url) return null;
    if (url.startsWith('//')) url = `${window.location.protocol}${url}`;
    if (url.includes('cdn.shopify.com') && !url.includes('width=')) {
      url += url.includes('?') ? '&' : '?';
      url += 'width=600';
    }
    return url;
  }

  function resolveImageFromItem(item) {
    if (!item) return null;
    if (item.image) return normalizeImageUrl(item.image);
    if (item.featured_image) return normalizeImageUrl(item.featured_image);
    if (item.images?.[0]) return normalizeImageUrl(item.images[0]);
    return null;
  }

  function parsePriceCents(item) {
    if (item?.price_cents != null) return Number(item.price_cents);
    if (item?.variants?.[0]?.price != null) return Number(item.variants[0].price);
    const raw = item?.price ?? item?.price_min ?? item?.price_max;
    if (raw == null) return 0;
    if (typeof raw === 'number') return raw;
    const numeric = Number(String(raw).replace(/[^\d.-]/g, ''));
    if (!Number.isFinite(numeric)) return 0;
    if (String(raw).includes('.') && numeric < 1000000) {
      return Math.round(numeric * 100);
    }
    return Math.round(numeric);
  }

  function normalizeProduct(item) {
    if (!item || Number(item.id) === productId) return null;
    const url = item.url || (item.handle ? `${rootPath}products/${item.handle}` : null);
    if (!url) return null;
    return {
      id: item.id,
      handle: item.handle || productHandle(url),
      url,
      title: item.title || '',
      vendor: item.vendor || '',
      price_cents: parsePriceCents(item),
      image: resolveImageFromItem(item),
    };
  }

  function renderCard(product) {
    const card = document.createElement('a');
    card.href = product.url;
    card.className = 'product-card product-card--carousel';
    const imageWrap = document.createElement('div');
    imageWrap.className = 'product-card__image';
    fillProductCardImageWrap(imageWrap, { src: product.image, title: product.title });
    const info = document.createElement('div');
    info.className = 'product-card__info';
    if (product.vendor) {
      const vendor = document.createElement('p');
      vendor.className = 'product-card__vendor';
      vendor.textContent = product.vendor;
      info.appendChild(vendor);
    }
    const title = document.createElement('p');
    title.className = 'product-card__title';
    title.textContent = product.title;
    const price = document.createElement('p');
    price.className = 'product-card__price';
    price.textContent = formatMoney(product.price_cents);
    info.appendChild(title);
    info.appendChild(price);
    card.appendChild(imageWrap);
    card.appendChild(info);
    return card;
  }

  async function fetchProductImageByHandle(handle) {
    if (!handle) return null;
    try {
      const res = await fetch(`${rootPath}products/${handle}.js`, { credentials: 'same-origin' });
      if (!res.ok) return null;
      const data = await res.json();
      return normalizeImageUrl(data.featured_image || data.images?.[0] || null);
    } catch {
      return null;
    }
  }

  async function ensureProductImages(products) {
    const ready = [];
    for (const product of products) {
      let image = product.image;
      if (!image) {
        image = await fetchProductImageByHandle(product.handle || productHandle(product.url));
      }
      if (!image) continue;
      if (!isListablePriceCents(product.price_cents)) continue;
      ready.push({ ...product, image });
    }
    return ready;
  }

  function prepareHtmlCard(card) {
    const clone = card.cloneNode(true);
    clone.classList.add('product-card--carousel');
    const priceText = clone.querySelector('.product-card__price')?.textContent || '';
    const priceDigits = priceText.replace(/[^\d]/g, '');
    if (priceDigits === '1' || priceDigits === '100') return null;
    const img = clone.querySelector('.product-card__image img');
    if (!img) return null;
    const src = img.getAttribute('src') || img.currentSrc;
    if (!src || src.startsWith('data:')) return null;
    img.loading = 'lazy';
    if (src.includes('cdn.shopify.com') && !src.includes('width=')) {
      img.src = `${src}${src.includes('?') ? '&' : '?'}width=600`;
    }
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    return clone;
  }

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  async function fetchRecommendationsHtml() {
    if (!recommendationsUrl) return [];
    const res = await fetch(recommendationsUrl);
    if (!res.ok) return [];
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fragment = doc.querySelector('[data-product-related-cards]');
    if (!fragment) return [];
    return Array.from(fragment.querySelectorAll('.product-card'));
  }

  async function fetchSuggestProducts(query) {
    const params = new URLSearchParams({
      q: query,
      'resources[type]': 'product',
      'resources[limit]': String(limit),
      'resources[options[unavailable_products]]': 'last',
    });
    const res = await fetch(`${rootPath}search/suggest.json?${params.toString()}`);
    if (!res.ok) return [];
    const data = await res.json();
    const list = data.resources?.results?.products || [];
    return list.map(normalizeProduct).filter(Boolean);
  }

  async function fetchRecommendationsJson() {
    const params = new URLSearchParams({
      product_id: String(productId),
      limit: String(limit),
      intent: 'related',
    });
    const res = await fetch(`${rootPath}recommendations/products.json?${params.toString()}`);
    if (!res.ok) return [];
    const data = await res.json();
    return (data.products || []).map(normalizeProduct).filter(Boolean);
  }

  function updateMoreLink(categoryQuery) {
    if (!moreLink || !categoryQuery) return;
    const type = meta.productType || categoryQuery;
    const q = serializeFilterQuery('', [{ key: 'product_type', value: type }]);
    moreLink.href = `${rootPath}search?type=product&q=${encodeURIComponent(q)}`;
  }

  function initRelatedCarousel() {
    if (!prevBtn || !nextBtn) return;
    let index = 0;

    const cards = () => Array.from(track.querySelectorAll('.product-card'));
    const visibleCount = () => {
      const styles = getComputedStyle(slider || root);
      const raw = parseFloat(styles.getPropertyValue('--pr-visible')) || 4;
      return Math.max(1, Math.floor(raw));
    };

    function maxIndex() {
      return Math.max(0, cards().length - visibleCount());
    }

    function stepSize() {
      const first = cards()[0];
      if (!first) return 0;
      const gap = parseFloat(getComputedStyle(track).gap) || 14;
      return first.getBoundingClientRect().width + gap;
    }

    function update() {
      const max = maxIndex();
      if (index > max) index = max;
      track.style.transform = `translateX(-${index * stepSize()}px)`;
      prevBtn.disabled = index <= 0;
      nextBtn.disabled = index >= max;
      const showNav = cards().length > visibleCount();
      prevBtn.hidden = !showNav;
      nextBtn.hidden = !showNav;
    }

    prevBtn.addEventListener('click', () => {
      index = Math.max(0, index - 1);
      update();
    });
    nextBtn.addEventListener('click', () => {
      index = Math.min(maxIndex(), index + 1);
      update();
    });
    window.addEventListener('resize', () => update());
    update();
  }

  async function loadRelated() {
    const byKey = new Map();

    const addProduct = (product) => {
      if (!product) return;
      const key = product.handle || productHandle(product.url) || String(product.id);
      if (!key || key === String(productId)) return;
      if (!byKey.has(key)) byKey.set(key, product);
    };

    try {
      const htmlCards = await fetchRecommendationsHtml();
      htmlCards.forEach((card) => {
        const prepared = prepareHtmlCard(card);
        const href = card.getAttribute('href');
        if (!prepared || !href) return;
        addProduct({
          id: href,
          handle: productHandle(href),
          url: href,
          html: prepared,
        });
      });
    } catch {
      /* ignore */
    }

    try {
      const jsonProducts = await fetchRecommendationsJson();
      jsonProducts.forEach((p) => addProduct(p));
    } catch {
      /* ignore */
    }

    for (const query of categoryQueries()) {
      if (byKey.size >= limit * 2) break;
      try {
        const found = await fetchSuggestProducts(query);
        found.forEach((p) => addProduct(p));
      } catch {
        /* ignore */
      }
    }

    const htmlItems = [];
    const dataItems = [];
    byKey.forEach((item) => {
      if (item.html instanceof Element) htmlItems.push(item);
      else dataItems.push(item);
    });

    const enriched = await ensureProductImages(dataItems);
    const merged = [...htmlItems, ...enriched].slice(0, limit);

    track.innerHTML = '';
    if (loadingEl) loadingEl.hidden = true;

    if (!merged.length) {
      if (slider) slider.hidden = true;
      if (emptyEl) emptyEl.hidden = false;
      return;
    }

    if (emptyEl) emptyEl.hidden = true;
    if (slider) slider.hidden = false;

    const primaryQuery = categoryQueries()[0];
    updateMoreLink(primaryQuery);

    merged.forEach((item) => {
      if (item.html instanceof Element) {
        track.appendChild(item.html);
        return;
      }
      track.appendChild(renderCard(item));
    });

    initRelatedCarousel();
  }

  loadRelated().catch(() => {
    track.innerHTML = '';
    if (loadingEl) loadingEl.hidden = true;
    if (slider) slider.hidden = true;
    if (emptyEl) emptyEl.hidden = false;
  });
}

function buildCategoryTree(typeValues) {
  const parents = new Map();

  function ensureParent(name) {
    if (!parents.has(name)) {
      parents.set(name, { name, children: [], soloTypes: new Set() });
    }
    return parents.get(name);
  }

  typeValues.forEach((raw) => {
    const full = normalizeFilterValue(raw);
    if (!full) return;
    const parts = full.split(' / ').map((p) => p.trim()).filter(Boolean);
    if (parts.length === 1) {
      ensureParent(parts[0]).soloTypes.add(full);
      return;
    }
    const parentName = parts[0];
    const childShort = parts.slice(1).join(' / ');
    const node = ensureParent(parentName);
    if (!node.children.some((c) => c.full === full)) {
      node.children.push({ full, short: childShort });
    }
  });

  parents.forEach((node) => {
    if (node.soloTypes.has(node.name) && node.children.length) {
      if (!node.children.some((c) => c.full === node.name)) {
        node.children.unshift({ full: node.name, short: 'General' });
      }
      node.soloTypes.delete(node.name);
    }
    node.children.sort((a, b) => {
      if (a.short === 'General') return -1;
      if (b.short === 'General') return 1;
      return a.short.localeCompare(b.short, 'es', { sensitivity: 'base' });
    });
  });

  return Array.from(parents.values()).sort((a, b) =>
    a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })
  );
}

function parentCategoryTypeValues(parent) {
  const values = new Set();
  (parent.children || []).forEach((child) => values.add(child.full));
  (parent.soloTypes || []).forEach((t) => values.add(t));
  return Array.from(values);
}

function categoryTypeSearchUrl(typeValue) {
  return buildSearchUrlFromState({
    plain: '',
    filters: [{ key: 'product_type', value: typeValue }],
    sortBy: '',
  });
}

function categoryParentBrowseUrl(parent) {
  const types = parentCategoryTypeValues(parent);
  if (!types.length) {
    return buildSearchUrlFromState({ plain: '', filters: [], sortBy: '' });
  }
  if (types.length === 1) {
    return categoryTypeSearchUrl(types[0]);
  }
  const root = window.Shopify?.routes?.root || '/';
  const q = types.map((t) => `product_type:"${escapeFilterValue(t)}"`).join(' OR ');
  return `${root}search?type=product&q=${encodeURIComponent(q)}`;
}

let orMegaMenuTreeCache = [];
let orMegaMenuActiveId = null;

function megaParentId(parent) {
  return parent.name;
}

function megaParentChildCount(parent) {
  const types = parentCategoryTypeValues(parent);
  return Math.max(parent.children.length, types.length);
}

function renderMegaDetail(parent) {
  const wrap = document.createElement('div');
  wrap.className = 'or-mega__detail-inner';

  const types = parentCategoryTypeValues(parent);
  const parentHref =
    types.length > 0
      ? categoryParentBrowseUrl(parent)
      : categoryTypeSearchUrl(parent.name);

  const head = document.createElement('header');
  head.className = 'or-mega__detail-head';
  head.innerHTML = `
    <p class="or-mega__detail-eyebrow">Familia</p>
    <div class="or-mega__detail-head-row">
      <h3 class="or-mega__detail-title"></h3>
      <a class="or-mega__detail-all btn btn--outline-white" href="#">Ver todo</a>
    </div>
  `;
  head.querySelector('.or-mega__detail-title').textContent = parent.name;
  const allLink = head.querySelector('.or-mega__detail-all');
  allLink.href = parentHref;
  wrap.appendChild(head);

  if (parent.children.length > 0) {
    const grid = document.createElement('div');
    grid.className = 'or-mega__child-grid';
    parent.children.forEach((child) => {
      const a = document.createElement('a');
      a.className = 'or-mega__child-link';
      a.href = categoryTypeSearchUrl(child.full);
      a.textContent = child.short;
      grid.appendChild(a);
    });
    wrap.appendChild(grid);
  } else {
    const solo = document.createElement('p');
    solo.className = 'or-mega__detail-solo';
    solo.innerHTML = `Explora productos de <a href="${parentHref}">${parent.name}</a>.`;
    wrap.appendChild(solo);
  }

  return wrap;
}

function setMegaMenuActive(parent, { focusNav } = {}) {
  if (!parent) return;
  orMegaMenuActiveId = megaParentId(parent);
  const nav = document.querySelector('[data-or-mega-nav]');
  const detail = document.querySelector('[data-or-mega-detail]');
  if (!nav || !detail) return;

  nav.querySelectorAll('[data-or-mega-nav-item]').forEach((btn) => {
    const active = btn.dataset.orMegaNavItem === orMegaMenuActiveId;
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-selected', active ? 'true' : 'false');
  });

  detail.innerHTML = '';
  detail.appendChild(renderMegaDetail(parent));

  if (focusNav) {
    const activeBtn = nav.querySelector('[data-or-mega-nav-item].is-active');
    activeBtn?.focus({ preventScroll: true });
  }
}

function parentMatchesMegaFilter(parent, query) {
  if (!query) return true;
  const q = query.toLowerCase();
  if (parent.name.toLowerCase().includes(q)) return true;
  return (parent.children || []).some((c) =>
    c.short.toLowerCase().includes(q) || c.full.toLowerCase().includes(q)
  );
}

function updateMegaMenuMeta(visibleCount, total, query) {
  const meta = document.querySelector('[data-or-mega-meta]');
  if (!meta) return;
  if (query) {
    meta.textContent = `${visibleCount} de ${total} familias · filtro activo`;
  } else {
    meta.textContent = `${total} familias · elige una a la izquierda`;
  }
}

function buildMegaMenuBrowse(tree, { filterQuery = '' } = {}) {
  const nav = document.querySelector('[data-or-mega-nav]');
  const body = document.querySelector('[data-or-mega-body]');
  const detail = document.querySelector('[data-or-mega-detail]');
  if (!nav || !detail || !body) return;

  const query = filterQuery.trim().toLowerCase();
  const filtered = tree.filter((p) => parentMatchesMegaFilter(p, query));

  nav.innerHTML = '';
  filtered.forEach((parent) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'or-mega__nav-item';
    btn.dataset.orMegaNavItem = megaParentId(parent);
    btn.setAttribute('role', 'tab');
    const count = megaParentChildCount(parent);
    btn.innerHTML = `<span class="or-mega__nav-label">${parent.name}</span><span class="or-mega__nav-count">${count}</span>`;
    btn.addEventListener('mouseenter', () => setMegaMenuActive(parent));
    btn.addEventListener('focus', () => setMegaMenuActive(parent));
    btn.addEventListener('click', () => setMegaMenuActive(parent, { focusNav: true }));
    nav.appendChild(btn);
  });

  updateMegaMenuMeta(filtered.length, tree.length, query);

  if (!filtered.length) {
    detail.innerHTML =
      '<p class="or-mega__detail-empty">Ninguna categoría coincide. Prueba otra palabra o <a href="' +
      (window.Shopify?.routes?.root || '/') +
      'search?type=product">busca en toda la tienda</a>.</p>';
    orMegaMenuActiveId = null;
    return;
  }

  const keepActive = filtered.find((p) => megaParentId(p) === orMegaMenuActiveId);
  setMegaMenuActive(keepActive || filtered[0]);
}

function renderMobileMegaSection(parent) {
  const hasChildren = parent.children.length > 0;
  const types = parentCategoryTypeValues(parent);
  if (!hasChildren && types.length <= 1) {
    const a = document.createElement('a');
    a.className = 'mobile-drawer__mega-solo';
    a.href = categoryTypeSearchUrl(types[0] || parent.name);
    a.textContent = parent.name;
    return a;
  }

  const details = document.createElement('details');
  details.className = 'mobile-drawer__mega-group';

  const summary = document.createElement('summary');
  summary.className = 'mobile-drawer__mega-parent';
  summary.textContent = parent.name;
  details.appendChild(summary);

  const body = document.createElement('div');
  body.className = 'mobile-drawer__mega-children';

  parent.children.forEach((child) => {
    const a = document.createElement('a');
    a.className = 'mobile-drawer__mega-child';
    a.href = categoryTypeSearchUrl(child.full);
    a.textContent = child.short;
    body.appendChild(a);
  });
  const allIn = document.createElement('a');
  allIn.className = 'mobile-drawer__mega-child mobile-drawer__mega-child--all';
  allIn.href = categoryParentBrowseUrl(parent);
  allIn.textContent = `Todo ${parent.name}`;
  body.appendChild(allIn);

  details.appendChild(body);
  return details;
}

let orMegaMenuBuilt = false;
let orMegaMenuTreePromise = null;

function getMegaMenuTree() {
  if (!orMegaMenuTreePromise) {
    orMegaMenuTreePromise = getCatalogProducts().then((products) =>
      buildCategoryTree(typesFromProducts(products))
    );
  }
  return orMegaMenuTreePromise;
}

function fillMegaMenuTargets(tree) {
  orMegaMenuTreeCache = tree;
  const body = document.querySelector('[data-or-mega-body]');
  const loadingEl = document.querySelector('[data-or-mega-loading]');
  if (body) {
    body.hidden = false;
    buildMegaMenuBrowse(tree);
  }
  if (loadingEl) loadingEl.hidden = true;

  const filterInput = document.querySelector('[data-or-mega-filter]');
  if (filterInput && !filterInput.dataset.orMegaBound) {
    filterInput.dataset.orMegaBound = '1';
    let filterTimer = null;
    filterInput.addEventListener('input', () => {
      clearTimeout(filterTimer);
      filterTimer = setTimeout(() => {
        buildMegaMenuBrowse(orMegaMenuTreeCache, {
          filterQuery: filterInput.value,
        });
      }, 120);
    });
  }

  const mobileList = document.querySelector('[data-or-mobile-mega-list]');
  if (mobileList) {
    mobileList.innerHTML = '';
    tree.forEach((parent) => mobileList.appendChild(renderMobileMegaSection(parent)));
  }
}

function initCatalogMegaMenu() {
  const root = document.querySelector('[data-or-mega-root]');
  const panel = document.querySelector('[data-or-mega-panel]');
  const trigger = document.querySelector('[data-or-mega-trigger]');
  const loadingEl = document.querySelector('[data-or-mega-loading]');
  if (!root || !panel || !trigger) return;

  const desktopMq = window.matchMedia('(min-width: 991px)');
  let closeTimer = null;
  let open = false;

  function setPanelTop() {
    const header = document.querySelector('.site-header');
    const bar = document.querySelector('.announcement-bar');
    if (!header) return;
    const bottom = header.getBoundingClientRect().bottom;
    panel.style.setProperty('--or-mega-top', `${bottom}px`);
  }

  function setOpen(next) {
    open = next;
    root.classList.toggle('is-open', next);
    panel.hidden = !next;
    panel.setAttribute('aria-hidden', String(!next));
    trigger.setAttribute('aria-expanded', String(next));
    document.querySelector('.site-header')?.classList.toggle('is-mega-open', next);
    if (!next) {
      const filterInput = document.querySelector('[data-or-mega-filter]');
      if (filterInput?.value) {
        filterInput.value = '';
        if (orMegaMenuTreeCache.length) buildMegaMenuBrowse(orMegaMenuTreeCache);
      }
    }
    if (next) {
      setPanelTop();
      if (!orMegaMenuBuilt) {
        getMegaMenuTree()
          .then((tree) => {
            fillMegaMenuTargets(tree);
            orMegaMenuBuilt = true;
            if (loadingEl) loadingEl.hidden = true;
          })
          .catch(() => {
            if (loadingEl) loadingEl.textContent = 'No se pudieron cargar las categorías.';
          });
      } else if (loadingEl) {
        loadingEl.hidden = true;
      }
    }
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => setOpen(false), 220);
  }

  function cancelClose() {
    clearTimeout(closeTimer);
  }

  trigger.addEventListener('click', (e) => {
    if (!desktopMq.matches) return;
    e.preventDefault();
    setOpen(!open);
  });

  root.addEventListener('mouseenter', () => {
    if (!desktopMq.matches) return;
    cancelClose();
    setOpen(true);
  });
  root.addEventListener('mouseleave', () => {
    if (!desktopMq.matches) return;
    scheduleClose();
  });
  panel.addEventListener('mouseenter', cancelClose);
  panel.addEventListener('mouseleave', scheduleClose);

  panel.querySelectorAll('[data-or-mega-close]').forEach((el) => {
    el.addEventListener('click', () => setOpen(false));
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && open) setOpen(false);
  });

  document.addEventListener('click', (e) => {
    if (!open || !desktopMq.matches) return;
    if (root.contains(e.target) || panel.contains(e.target)) return;
    setOpen(false);
  });

  window.addEventListener('resize', () => {
    if (open) setPanelTop();
    if (!desktopMq.matches && open) setOpen(false);
  });
  window.addEventListener('scroll', () => {
    if (open) setPanelTop();
  }, { passive: true });

  document.querySelectorAll('[data-search-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => setOpen(false));
  });

  getMegaMenuTree()
    .then((tree) => {
      fillMegaMenuTargets(tree);
      orMegaMenuBuilt = true;
      if (loadingEl) loadingEl.hidden = true;
    })
    .catch(() => {});
}
